import { ProfileCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconProfileCircle12Line = createIcon(ProfileCircle, 12, "Line");
export const IconProfileCircle16Line = createIcon(ProfileCircle, 16, "Line");
export const IconProfileCircle20Line = createIcon(ProfileCircle, 20, "Line");
export const IconProfileCircle24Line = createIcon(ProfileCircle, 24, "Line");
export const IconProfileCircle32Line = createIcon(ProfileCircle, 32, "Line");
export const IconProfileCircle48Line = createIcon(ProfileCircle, 48, "Line");
export const IconProfileCircle64Line = createIcon(ProfileCircle, 64, "Line");
